module.exports = __webpack_public_path__ + "img/Philips423_player.38bbc914.png";